document.addEventListener("DOMContentLoaded", function() {
  console.log("Autoplay script loaded ✅");

  const deferredMediaElements = document.querySelectorAll("deferred-media");

  deferredMediaElements.forEach((media) => {
    media.addEventListener("click", () => {
      // जब user play button दबाए तब video DOM में load होगा
      setTimeout(() => {
        const video = media.querySelector("video");

        if (video) {
          console.log("Video मिला ✅", video);

          video.setAttribute("muted", "true");
          video.setAttribute("playsinline", "true");
          video.muted = true;

          video.play().then(() => {
            console.log("Autoplay ✅ चल गया");
          }).catch((err) => {
            console.log("Autoplay blocked ❌", err);
          });
        } else {
          console.log("❌ Video tag नहीं मिला");
        }
      }, 500); // थोड़ी delay ताकि video DOM में add हो जाए
    });
  });
});
